import * as React from 'react';

import { CheckboxGroup } from 'components/common/search-form/fields/checkbox-group';
import { SearchFormFieldProps } from 'components/common/search-form';

export const Price: React.FunctionComponent<SearchFormFieldProps> = (props) => {
  const { modelKey, sortAndFilterOptions } = props;
  const priceFilterOption = sortAndFilterOptions && sortAndFilterOptions[modelKey];
  if (!priceFilterOption) {
    return null;
  }

  return <CheckboxGroup {...props} />;
};
